<div class="common-padding">
  <app-bpg-events></app-bpg-events>
  <div id='included_page' class="form-outer-div">
    <div class="form-group">
      <span>
        <input id="date" name="date" class="date-control form-control"  bsDatepicker (onShown)="onOpenCalendar($event)" [ngModel]="date" [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" (ngModelChange)="onDateChange($event)">
      </span>
    </div>

   

    
    <div class="form-group">
      <ng-select placeholder ="--Select Site--" class="custom" [items]="siteList" bindLabel="siteName" [(ngModel)]="selectedSite" (change)="siteChange($event)"></ng-select> 
    </div>

   
    <div class="form-group">
      <ng-select placeholder ="--Select ERG--"  class="custom" [items]="bpgList" bindLabel ="bpgName" [(ngModel)]="selectedBpg" (change)="bpgChange($event)" ></ng-select> 
    </div>



    <div class="form-group">
      <input type="text" class="form-control keywords" id="search" placeholder="Search by event name" [(ngModel)]="searchKey">
    </div>
    <div id="searchSecn" style="display: inline-flex;"> 
      <button type="button" class="btn btn-danger" (click)="searchEvents()">Search</button>
      <span class="download-icon mt-1 pt-2 pl-3 color" [ngClass]="{'disabled': !(this.printEventsList!=null && this.printEventsList!=undefined && this.printEventsList.length>0)}" (click)="downloadEvents()"><mat-icon class="download-style" matTooltip="download">download</mat-icon></span>
      <span class="download-icon mt-1 pt-2 pl-4 color" [ngClass]="{'disabled': !(this.printEventsList!=null && this.printEventsList!=undefined && this.printEventsList.length>0)}" (click)="printEvents()"><mat-icon class="download-style" matTooltip="print">print</mat-icon></span>
    </div>
  </div>

  <div class="form-outer-div-two">
    <div class="start-date-btn">
      <button type="button" id="prevBtn" class="btn form-control next-prev-height" (click)="previousMonthClick()"><i class="fa fa-angle-left arrow-icon" aria-hidden="true"></i>{{prevMonth | date :'MMM yyyy'}}</button>
    </div>
   
    <div class="end-date-btn">
      <button type="button" id="nextBtn" class="btn form-control btn-enddate next-prev-height" (click)="nextMonthClick()">{{nextMonth | date :'MMM yyyy'}}<i class="fa fa-angle-right arrow-icon" aria-hidden="true"></i></button>
    </div>
  </div>
  

  <div class="event-list-outerdiv">
    <div *ngFor="let events of eventList | paginate: { itemsPerPage: limit, currentPage: currentPage,totalItems: numberOfElements }" class="event-list">

      <div class="date_span">
        <span class="date-style">{{events.eventDay}}</span><br>
        <span class="month-style">{{events.eventMonth}}</span>
      </div>
      <div class="events_info">
          <span class="filteredBpg">{{events.filteredSiteName}}</span><span class="colon-padding filteredBpg">-</span><span class="filteredBpg">{{events.filteredBpgName}}</span><span class="colon-padding filteredBpg">-</span><span class="event-name-span">{{events.eventName}}</span>
        <div class="event-time-loc">
          <span class="common-line-height">{{events.startTime}}</span> to <span>{{events.endTime}}</span><span> {{events.timeZone}} </span><span class="common-line-height"><span class="pipe-padding">|</span>{{events.venue}}</span><br>
          <div class="view-details-align">
            <span class="common-line-height">{{events.bpgName}}<span class="common-line-height"></span></span>
            <span class="view-details" (click)="viewEventDetails(events)">View Details >></span>
          </div>
        </div>

      </div>
    </div>
    <p class="noDataFound text-center" *ngIf="noDataFound"> No data found </p>
    <div id="bpgpagination" *ngIf="numberOfElements > limit" class="pagination-outerdiv">
        <span>Showing {{currentShowingElements}} of {{numberOfElements}} results</span>
        <pagination-controls previousLabel="Prev" nextLabel="Next" (pageChange)="pageChanged($event)"></pagination-controls>
      </div>
  </div>
</div>
<div id="printEvents" [hidden]="true">
  <div class="mt-3 mb-2">
      <div class="text-center"
          *ngIf="this.siteNamePrint=='Select All' && this.bpgNamePrint=='Select All'">
          <h2>Events Report</h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint!=='Select All' && this.bpgNamePrint!=='Select All'">
          <h2>Events Report for {{siteNamePrint}} - {{bpgNamePrint}} </h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint!='Select All' && this.bpgNamePrint=='Select All'">
          <h2>Events Report for All {{siteNamePrint}}</h2>
      </div>
      <div class="text-center" *ngIf="this.siteNamePrint=='Select All' && this.bpgNamePrint!='Select All'">
        <h2>Events Report for All {{bpgNamePrint}}</h2>
    </div>
  </div>
  <div *ngFor="let events of eventList">
      <div class="m-4 event-list event-list-outerdiv">
          <div class="date_span">
              <span class="date-style">{{events.eventDay}}</span><br>
              <span class="month-style">{{events.eventMonth}}</span>
          </div>
          <div class="events_info">
              <span class="filteredBpg">{{events.siteName}}</span><span
                  class="colon-padding filteredBpg">-</span><span class="filteredBpg">{{events.bpgName}}</span><span
                  class="colon-padding filteredBpg"> -
              </span><span class="event-name-span">{{events.eventName}}</span>
              <div class="event-time-loc">
                  <span class="common-line-height">{{events.startTime}}</span> to
                  <span>{{events.endTime}}</span><span> {{events.timeZone}} </span><br>
                  <div class="view-details-align">
                      <span class="common-line-height">{{events.description}}<span
                              class="common-line-height"></span></span>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


